'use client'

import { DropdownMenuItem, type NavbarItemVariant, NavbarLink } from '@portal/taonga-ui'

import { css, cx } from '@news/styled-system/css'
import { getPublicEnv } from '@/shared/env'
import { useI18n } from '@/shared/providers'

export function KnowledgeBaseLink({ variant = 'default' }: { variant?: NavbarItemVariant }) {
    const runtimeEnv = getPublicEnv()
    const { i18n } = useI18n()
    const href = runtimeEnv.NEXT_PUBLIC_ZENDESK_URL

    if (variant === 'default') {
        return (
            <NavbarLink href={href} className={css({ display: { base: 'none', xl: 'flex' } })}>
                {i18n.PORTAL_KNOWLEDGE_BASE}
            </NavbarLink>
        )
    }

    return (
        <DropdownMenuItem href={href} target="_blank" rel="noopener noreferrer">
            <i className={cx('fa-light fa-book', css({ color: 'success', paddingX: '[1px]', width: '3' }))} />
            &nbsp;{i18n.PORTAL_KNOWLEDGE_BASE}
        </DropdownMenuItem>
    )
}
